import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseUsersAvailableHoursPayload } from '../payloads/usersAvailableHoursPayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';

export const buildUsersAvailableHoursInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseUsersAvailableHoursPayload(payload);
  const { total_available_hours } = parsedPayload.data.attributes.aggregate;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.KPI)
      .setProps({
        chartData: {
          value: total_available_hours.current ?? 0,
          trend: total_available_hours.percentage_change ?? 0,
          trendIsPercent: true,
          description: props.name,
        },
        onDrillDown: props.onDrillDown,
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
